import { Fingerprint } from "lucide-react";

const status = (pct, complete) => {
  if (complete) return "SUBJECT IDENTIFIED";
  if (pct === 0) return "NO DATA";
  if (pct < 34) return "PATTERN EMERGING";
  if (pct < 67) return "PROFILE FORMING";
  return "MATCHED TO SITE STAFF";
};

export const IdentityGauge = ({ decoded, total, complete }) => {
  const pct = total ? Math.round((decoded / total) * 100) : 0;
  return (
    <section data-testid="origin-gauge" className={`border p-5 transition-colors ${complete ? "border-rose-400/50 bg-rose-400/5" : "border-cyan-400/20 bg-slate-950/70"}`}>
      <div className="flex items-center justify-between">
        <span className="lab-label flex items-center gap-2"><Fingerprint size={12} /> Identity match</span>
        <span data-testid="origin-verdict" className={`font-mono text-xs tracking-[0.25em] ${complete ? "text-rose-300" : "text-cyan-300"}`}>{status(pct, complete)}</span>
      </div>
      <div className="mt-4 h-3 w-full bg-slate-800/80">
        <div className={`h-full transition-[width] duration-700 ${complete ? "bg-rose-400 shadow-[0_0_12px_#ff2a6d]" : "meter-on"}`} style={{ width: `${pct}%` }} />
      </div>
      <p data-testid="origin-confidence" className="mt-3 font-mono text-xs tracking-widest text-slate-400">
        {complete ? "CROSS-REFERENCE COMPLETE - SEE CASE FILE" : `PROFILE CONFIDENCE ${pct}%`}
      </p>
    </section>
  );
};
